import { Button as AntdButton } from 'antd';
import { ButtonProps, ButtonWidth, defaultProps } from './Button.type';
import styles from "./Button.module.scss"
import cx from "classnames";

export const Button = (props: ButtonProps) => {
  const { children, className, width, ...attributes } = { ...defaultProps, ...props };

  return (
    <AntdButton
      {...attributes}
      className={cx(
        className,
        styles.Button,
        width === ButtonWidth.Full && styles.Full
      )}
    >
      {children}
    </AntdButton>
  );
};
